import { SagaReturnType, call, put, takeEvery } from 'redux-saga/effects';
import monthlyCloseoutService from 'src/services/apiServices/monthlyCloseOut/monthlyCloseoutService';
import { monthCloseOutAlertConstants } from '../../actions/constant';

const {
  GET_MONTH_CLOSE_OUT_ALERT_REQUEST,
  GET_MONTH_CLOSE_OUT_ALERT_SUCCESS,
  GET_MONTH_CLOSE_OUT_ALERT_FAILURE,
  GET_MONTH_CLOSE_OUT_ALERT_RESET,
  GET_MONTH_CLOSE_OUT_ALERT_LOADING,
} = monthCloseOutAlertConstants;
function* monthlyCloseoutAlert(action: any): SagaReturnType<any> {
  try {
    yield put({ type: GET_MONTH_CLOSE_OUT_ALERT_LOADING });
    const response = yield call(monthlyCloseoutService.getMonthlyCloseOut, action.payload);

    if (response?.status === 200) {
      yield put({ type: GET_MONTH_CLOSE_OUT_ALERT_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: GET_MONTH_CLOSE_OUT_ALERT_FAILURE, payload: error });
  }
}

function* monthlyCloseoutAlertSaga() {
  yield takeEvery(GET_MONTH_CLOSE_OUT_ALERT_REQUEST, monthlyCloseoutAlert);
}

export default monthlyCloseoutAlertSaga;
